export default `MARKDOWN:
Betal medlemsavgiften til:
- Kontonummer: 4200 32 16513
- Vipps: #622814

**Husk å merke betalingen med navnet ditt!**

*For exchange students: Payment must be made by card at our payment terminal at Moholt student village. Please email mail@studenteneskameraklubb.no to arrange a meeting with a board member, who will help you complete the payment and registration process. Our bank charges a 50 NOK fee for international transfers, so this is the easiest solution.

Når vi har bekreftet betalingen din, er du offisielt medlem av Studentenes Kameraklubb.
Hvis du støter på noen problemer, ikke nøl med å kontakte oss via e-post eller Facebook.
`;
